import { dispatchStorageEvent } from "./dispatch-storage-event.ts";

export function removeLocalStorageItem(key: string) {
  window.localStorage.removeItem(key);
  dispatchStorageEvent(key, null);
}
